import LoginRegister from "./components/LoginRegister";
import { Routes, Route } from "react-router-dom";
import "./App.css";

function App() {
  return (
    <div className="h5-container">
      <Routes>
        <Route path="/" element={<LoginRegister />} />
      </Routes>
    </div>
  );
}

export default App;
